module.exports = __webpack_public_path__ + "static/media/ElevatedELS.f808a183.png";